import { render, staticRenderFns } from "./gForm.vue?vue&type=template&id=0724c690&scoped=true&"
import script from "./gForm.vue?vue&type=script&lang=js&"
export * from "./gForm.vue?vue&type=script&lang=js&"
import style0 from "./gForm.vue?vue&type=style&index=0&id=0724c690&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0724c690",
  null
  
)

export default component.exports